import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  useDisclosure,
  Box,
  Input,
  Flex,
  IconButton,
} from '@chakra-ui/react';
import FloatingAddButton from '../../../components/FloatingAddButton';
import { useEffect, useState } from 'react';
import { SearchIcon } from '@chakra-ui/icons';
import ModalOficialia from './ModalOficialia';
import { OficialiaFormulario } from './types'; // Asegúrate que la ruta sea correcta
import ModalHistorialOficialia from './ModalHistorialOficialia';

const TablaOficialia = () => {
  const [data, setData] = useState<OficialiaFormulario[]>([]);
  const [filtro, setFiltro] = useState('');
  const [modalData, setModalData] = useState<OficialiaFormulario | null>(null);
  const [modo, setModo] = useState<'view' | 'edit' | 'new'>('new');
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [registroSeleccionado, setRegistroSeleccionado] =
    useState<OficialiaFormulario | null>(null);
  const {
    isOpen: isOpenHistorial,
    onOpen: onOpenHistorial,
    onClose: onCloseHistorial,
  } = useDisclosure();

  // Obtener datos desde el backend
  const fetchOficios = () => {
    fetch('https://totolac-backend.togui.com.mx/api/oficialia')
      .then((res) => res.json())
      .then(setData);
  };

  useEffect(() => {
    fetchOficios();
  }, []);

  const openModal = (
    modo: 'view' | 'edit' | 'new',
    registro?: OficialiaFormulario,
  ) => {
    setModo(modo);
    setModalData(registro || null);
    onOpen();
  };

  const filteredData = data.filter(
    (of) =>
      of.remitente?.toLowerCase().includes(filtro.toLowerCase()) ||
      of.asunto?.toLowerCase().includes(filtro.toLowerCase()) ||
      of.estado?.toLowerCase().includes(filtro.toLowerCase()),
  );

  return (
    <Box p={4} pt="79px">
      <Flex mb={4} gap={4}>
        <Input
          placeholder="Buscar por remitente, asunto o estado"
          value={filtro}
          onChange={(e) => setFiltro(e.target.value)}
        />
        <IconButton aria-label="Buscar" icon={<SearchIcon />} />
      </Flex>

      <Table size="sm" variant="striped" colorScheme="gray">
        <Thead>
          <Tr>
            <Th>Folio</Th>
            <Th>Remitente</Th>
            <Th>Dependencia</Th>
            <Th>Tipo</Th>
            <Th>Asunto</Th>
            <Th>Fecha</Th>
            <Th>Estado</Th>
            <Th>Acciones</Th>
          </Tr>
        </Thead>
        <Tbody>
          {filteredData.map((oficio) => (
            <Tr key={oficio.id}>
              <Td>{oficio.id?.toString().padStart(4, '0') ?? '----'}</Td>
              <Td>{oficio.remitente}</Td>
              <Td>{oficio.dependencia}</Td>
              <Td>{oficio.tipoDocumento}</Td>
              <Td>{oficio.asunto}</Td>
              <Td>{new Date(oficio.fechaRecepcion).toLocaleDateString()}</Td>
              <Td>{oficio.estado}</Td>
              <Td>
                <Button size="xs" onClick={() => openModal('view', oficio)}>
                  Ver
                </Button>
                <Button
                  size="xs"
                  ml={2}
                  onClick={() => openModal('edit', oficio)}
                >
                  Editar
                </Button>
                <Button
                  size="sm"
                  colorScheme="gray"
                  onClick={() => {
                    setRegistroSeleccionado(oficio); // o row.id si así lo manejas
                    onOpenHistorial();
                  }}
                >
                  Historial
                </Button>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>

      <FloatingAddButton 
        text="Nuevo Oficio" 
        onClick={() => openModal('new')} 
      />
      {registroSeleccionado && (
        <ModalHistorialOficialia
          isOpen={isOpenHistorial}
          onClose={onCloseHistorial}
          oficialiaId={registroSeleccionado.id!}
        />
      )}

      <ModalOficialia
        isOpen={isOpen}
        onClose={onClose}
        data={modalData}
        modo={modo}
        onGuardar={() => {
          onClose();
          fetchOficios();
        }}
      />
    </Box>
  );
};

export default TablaOficialia;
